import { render, staticRenderFns } from "./push-list.vue?vue&type=template&id=0ec591bd&"
import script from "./push-list.vue?vue&type=script&lang=ts&"
export * from "./push-list.vue?vue&type=script&lang=ts&"
import style0 from "./push-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports